import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetChannelMessage } from "../schemas/schemas_0";
export { $Command };
export class GetChannelMessageCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "GetChannelMessage", {})
    .n("ChimeSDKMessagingClient", "GetChannelMessageCommand")
    .sc(GetChannelMessage)
    .build() {
}
